import React from 'react'
import { Link } from 'react-router-dom'

interface ActionCardProps {
    to: string
    icon: React.ReactNode
    title: string
    description: string
}

// A whole-card link, so it works with keyboard, middle-click and "open in new tab"
const ActionCard: React.FC<ActionCardProps> = ({ to, icon, title, description }) => (
    <Link to={to} className="action-card">
        <span className="action-card-icon">{icon}</span>
        <span className="action-card-body">
            <span className="action-card-title">{title}</span>
            <span className="action-card-description">{description}</span>
        </span>
    </Link>
)

export default ActionCard
